
import React, {useEffect, useRef, useState} from "react";
import CategoryService from "./httpService";
import {handleError} from "../../service/HandleErrorService";
import {ResponsiveDataTable} from "../../components/ResponsiveDataTable";
import {Toast} from "primereact/toast";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {ConfirmDialog} from "primereact/confirmdialog";
import {TabPanel, TabView} from "primereact/tabview";
import {Dropdown} from "primereact/dropdown";
import {DataTable} from "primereact/datatable";

const CategoryView = () => {

  const toast = useRef(null);
  const [allSubCategories, setAllSubCategories] = useState([]);

  const dt = useRef(null);
  const [allCategories, setAllCategories] = useState([]);
  const categoryService = new CategoryService();
  const [deleteSubCategoryDialog, setDeleteSubCategoryDialog] = useState(false);
  const [deleteSubCategoryId, setDeleteSubCategoryId] = useState();
  const [createSubCategory, setCreateSubCategory] = useState({});
  const [editSubCategory, setEditSubCategory] = useState({});
  const [upsertCategory, setUpsertCategory] = useState();
  const [createCategory, setCreateCategory] = useState();
  const [deleteCategory, setDeleteCategory] = useState();
  const [selectedRepresentative, setSelectedRepresentative] = useState();
  const [createSubCategoryShow, setCreateSubCategoryShow] = useState(false);
  const [editSubCategoryShow, setEditSubCategoryShow] = useState(false);
  const [scoreLabel, setScoreLabel] = useState();
  const [selectScoreType, setSelectScoreType] = useState();
  const [editCategoryDialog, setEditCategoryDialog] = useState(false);
  const [editCategoryHeader, setEditHeader] = useState(false);
  const [deleteCategoryDialog, setDeleteCategoryDialog] = useState(false);
  const [deleteCategoryHeader, setDeleteHeader] = useState(false);
  const [errorFields, setErrorFields] = useState({});
  const [allScoreTypes, setAllScoreTypes] = useState([]);

  const sortData = (data) => {
    const x = data?.sort(function(a, b){
    if(a.name < b.name) { return -1; }
    if(a.name > b.name) { return 1; }
    return 0;
})
return x;
}

  useEffect(() => {
    getAll();
    getAllSubCategories();
    getAllScoreTypes();
  }, [])


  const getAllScoreTypes = () => {
    categoryService.getAllScoreType().then(res => {
      setAllScoreTypes(res?.map(value => {

        return {
          name: value.value,
          value: value.key
        }
      }));
    });
  }
  const getAll = () => {
    categoryService.getAll().then(res => {

      setAllCategories(sortData(res))
    }).catch(handleError)
  }

  const getAllSubCategories = () => {
    categoryService.getAllSubCategories().then(res => {
      setAllSubCategories(sortData(res))
    }).catch(err => handleError(err, toast))
  }


  const hideEditDialog = () => {

    setEditCategoryDialog(false);
    setErrorFields({});
    setUpsertCategory(null);
  }




  const hideCreateSubCategoryDialog = () => {
    setCreateSubCategoryShow(false);
    setCreateSubCategory(null);
    setErrorFields({});
    setScoreLabel("");

  }
  const hideEditSubCategoryDialog = () => {
    setEditSubCategoryShow(false);
    setEditSubCategory(null);
    setErrorFields({});
    setScoreLabel("");
  }

 
  const editSubCategoryModal = (e, rowData) => {
    setEditSubCategory(rowData);
    setEditSubCategoryShow(true);
    if (rowData.productScoreType === "UNIT") {
      setScoreLabel("Puan")
    } else if (rowData.productScoreType === "AMOUNT") {
      setScoreLabel("Oran")
    } else {
      setScoreLabel("");
    }


  }

  const actionsSubCategories = (rowData) =>

    <div><Button
      icon="pi pi-pencil"
      className="p-button-rounded p-button-warning p-mr-2"
      label="Düzenle"

      onClick={e => editSubCategoryModal(e, rowData)}
    />
      <Button onClick={e => {
        setDeleteSubCategoryDialog(true);
        setDeleteSubCategoryId(rowData.id)
      }} icon="pi pi-times" className="p-button-rounded p-button-danger"/>
    </div>

  const isInvalid = (bindingField1, bindingField2) => {
    if (errorFields[`${bindingField1}`]) {

      return " p-invalid";
    }
    if (errorFields[`${bindingField2}`]) {
      return " p-invalid";
    }
    return "";
  }
  const showSubCategoryDialog = () => {

    setCreateSubCategoryShow(true);
  }
  const changeModel = (e) => {
    let _upsertCategory = {...upsertCategory};
    _upsertCategory.name = e.target.value;
    setUpsertCategory(_upsertCategory)
  }
  const changeCategory = (e, name) => {
    let _createCategory = {...createCategory};
    _createCategory.name = e.target.value;
    setCreateCategory(_createCategory)

  }
  const upsert = () => {
    categoryService.upsert(upsertCategory).then(res => {
      getAll();
      toast.current?.show({
        severity: "success",
        detail: "İşlem Başarılı",
        life: 3000,
      });
      setEditCategoryDialog(false);


    }).catch(err => setErrorFields(handleError(err, toast)))
  }

  const createNew = () => {

    setCreateCategory({name: ""});
    categoryService.upsert(createCategory).then(res => {
      toast.current?.show({
        severity: "success",
        detail: "İşlem Başarılı",
        life: 3000,
      });
      getAll();
    }).catch(err => setErrorFields(handleError(err, toast)))
  }

  const upsertSubCategory = (subCategory) => {

    categoryService.upsertSubCategories(subCategory).then(res => {
      getAllSubCategories();
      toast.current?.show({
        severity: "success",
        detail: "İşlem Başarılı",
        life: 3000,
      });
      setCreateSubCategory(null);
      setCreateSubCategoryShow(false);
      setEditSubCategory({});
      setEditSubCategoryShow(false);
    }).catch(err => setErrorFields(handleError(err, toast)));


  }
  const accept = () => {
    categoryService.delete(deleteCategory.id).then(res => {
      toast.current?.show({
        severity: "success",
        detail: "İşlem Başarılı",
        life: 3000,
      });

      getAll();
      getAllSubCategories();

    }).catch(err => handleError(err, toast))
  }
  const acceptSubCategory = () => {

    categoryService.deleteSubCategories(deleteSubCategoryId).then(res => {
      toast.current?.show({
        severity: "success",
        detail: "İşlem Başarılı",
        life: 3000,
      });
      getAllSubCategories();


    }).catch(err => handleError(err, toast))
  }


  const onRepresentativesChange = (e) => {

    dt.current?.filter(e.value, 'category.name', 'equals');
    setSelectedRepresentative(e.value)
  }

  const onScoreChange = (e) => {
    console.log(allScoreTypes)
    dt.current?.filter(e.value, 'productScoreType', 'equals');
    setSelectScoreType(e.value)
  }

  const scoreItemTemplate = (option) => {
    return (
      <div className="p-multiselect-representative-option">
        <span className="image-text">{option.name}</span>
      </div>
    );
  }

  const representativesItemTemplate = (option) => {
    return (
      <div className="p-multiselect-representative-option">
        <span className="image-text">{option.name}</span>
      </div>
    );
  }


  const subCategoryTemplate = (e) => {


    return <div style={{paddingLeft: 8}}>{e?.name}</div>
  }


  const categoryTemplate = (e) => {


    return <div style={{paddingLeft: 8}}>{e?.category?.name}</div>
  }

  const scoreRatioTemplate = (e) => {


    return <div style={{paddingLeft: 8}}>{e?.scoreRatio}</div>
  }

  const scoreTypeTemplate = (e) => {

    let _scoreType = allScoreTypes.find(score => score.value === e?.productScoreType);

    return <div style={{paddingLeft: 8}}>{_scoreType?.name}</div>
  }

  const representativeFilter = <Dropdown value={selectedRepresentative} options={allCategories}
                                         itemTemplate={representativesItemTemplate} onChange={onRepresentativesChange}
                                         optionLabel="name" optionValue="name" placeholder="Kategoriler"
                                         showClear
                                         className="p-column-filter"/>;


  const scoreFilter =
    <Dropdown id="productScoreType" value={selectScoreType}
              options={allScoreTypes} optionLabel="name" optionValue="value" placeholder="Skor Tipi"
              itemTemplate={scoreItemTemplate} onChange={e => onScoreChange(e)}
              showClear
              className="p-column-filter"/>;

  return (
    <>
      <Toast ref={toast}/>
      <TabView>
        <TabPanel header="Kategori Yönetimi">


          <ResponsiveDataTable

            header="Kategori Listesi"
            value={allCategories}
          >
            <Column field="name" header="Kategori" filter filterPlaceholder="Kategori Ara"/>


          </ResponsiveDataTable>

        </TabPanel>
        <TabPanel header="Alt Kategori Yönetimi">

          <DataTable value={allSubCategories}
                     ref={dt}>

            <Column field="category.name" header="Kategori" body={categoryTemplate} filter
                    filterElement={representativeFilter} headerStyle={{paddingLeft: 20}}/>
            <Column field="name" header="Alt Kategori" body={subCategoryTemplate} filter
                    filterPlaceholder="Alt Kategori Ara" filterMatchMode="contains" headerStyle={{paddingLeft: 20}}/>



          </DataTable>


        </TabPanel>

      </TabView>
    </>
  )

}
export default CategoryView;
